import { useEffect, useState } from 'react';
import { UncontrolledTooltip } from 'reactstrap';
import moment from 'moment';

interface ClockTooltipProps {
    target: string;
}

const ClockTooltip = ({ target }: ClockTooltipProps) => {
    const [time, setTime] = useState(moment().format('HH:mm:ss'));

    useEffect(() => {
        const timer = setInterval(() => {
            setTime(moment().format('HH:mm:ss'));
        }, 1000);
        return () => clearInterval(timer);
    }, []);

    return (
        <UncontrolledTooltip target={target} placement="bottom">
            {time}
        </UncontrolledTooltip>
    );
};

export default ClockTooltip;
